/**
 * Collection pipeline API contract.
 * Manual trigger, execution status, and execution list endpoints.
 */
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { CollectionTriggerSchema, ExecutionRecordSchema, ErrorResponseSchema, PaginationQuerySchema, DateRangeQuerySchema, PaginationMetaSchema, ExecutionStatusSchema, } from './schemas';
const c = initContract();
export const collectionContract = c.router({
    trigger: {
        method: 'POST',
        path: '/collection/trigger',
        body: CollectionTriggerSchema,
        responses: {
            202: z.object({
                success: z.literal(true),
                data: z.object({
                    executionId: z.string(),
                    status: z.literal('running'),
                }),
            }),
            400: ErrorResponseSchema,
            401: ErrorResponseSchema,
            409: ErrorResponseSchema,
        },
        summary: 'Trigger a collection pipeline execution',
    },
    getExecution: {
        method: 'GET',
        path: '/collection/executions/:executionId',
        pathParams: z.object({ executionId: z.string() }),
        responses: {
            200: z.object({
                success: z.literal(true),
                data: ExecutionRecordSchema,
            }),
            401: ErrorResponseSchema,
            404: ErrorResponseSchema,
        },
        summary: 'Get a collection execution by ID',
    },
    listExecutions: {
        method: 'GET',
        path: '/collection/executions',
        query: PaginationQuerySchema.merge(DateRangeQuerySchema).extend({
            status: ExecutionStatusSchema.optional(),
        }),
        responses: {
            200: z.object({
                success: z.literal(true),
                data: z.array(ExecutionRecordSchema),
                meta: PaginationMetaSchema.optional(),
            }),
            401: ErrorResponseSchema,
        },
        summary: 'List collection executions',
    },
});
//# sourceMappingURL=collection.js.map